"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TextFormFieldCustom;

var _react = _interopRequireDefault(require("react"));

var _TextFormField = _interopRequireDefault(require("./TextFormField"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _excluded = ["inputRef", "onChange"],
    _excluded2 = ["inputRef", "onChange"],
    _excluded3 = ["rupiah", "percent"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function NumberFormatRupiah(props) {
  var inputRef = props.inputRef,
      onChange = props.onChange,
      other = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], _extends({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          name: props.name,
          value: values.value
        }
      });
    },
    thousandSeparator: ".",
    decimalSeparator: ",",
    isNumericString: true,
    prefix: "Rp"
  }));
}

function NumberFormatPercent(props) {
  var inputRef = props.inputRef,
      onChange = props.onChange,
      other = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], _extends({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          name: props.name,
          value: values.value
        }
      });
    },
    thousandSeparator: ".",
    decimalSeparator: ",",
    isNumericString: true,
    suffix: "%"
  }));
}

function TextFormFieldCustom(props) {
  var rupiah = props.rupiah,
      percent = props.percent,
      other = _objectWithoutProperties(props, _excluded3);

  return /*#__PURE__*/_react["default"].createElement(_TextFormField["default"], _extends({}, other, {
    InputProps: {
      inputComponent: rupiah ? NumberFormatRupiah : percent ? NumberFormatPercent : null
    }
  }));
}